import { Ubicacion } from '@/domain/entities/ubicacion';
import { IUbicacionRepository } from '@/domain/repositories/IUbicacionRepository';

export class UpdateUbicacionUseCase {
  constructor(
    private readonly repository: IUbicacionRepository
  ) {}

  execute(
    id: string,
    data: Omit<Ubicacion, 'id'>
  ): Promise<Ubicacion> {
    return this.repository.update(id, data);
  }
}
